<template>
  
    <section class="slide-bg" id="home">
        <div class="animation-circle">
            <i></i>
            <i></i>
            <i></i>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="d-flex-1">
                        <div class="slide-text">
                            <div>
                                <h1>أفضل طريقة للتواصل مع أصدقائك هي
                                    <span class="main-title">دردشة حلقة!</span>
                                </h1>
                                <h4>لوريم إيبسوم هو ببساطة نص شكلي في صناعة الطباعة والتنضيد.أبجد هوز </h4>
                                <div class="slid-btn">
                                    <a href="#"><img src="../../assets/images/app1.png" alt="app1" class="img-fluid" data-tilt
                                                     data-tilt-perspective="50" data-tilt-speed="350" data-tilt-max="1.8"></a>
                                    <a href="#"><img src="../../assets/images/app2.png" alt="app2" class="img-fluid" data-tilt
                                                     data-tilt-perspective="50" data-tilt-speed="350" data-tilt-max="1.8"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="home-right">
                        <div class="mobile-slid">
                            <img src="../../assets/images/top-mobile.png" alt="top1" class="img-fluid">
                        </div>
                        <div class="profile-msg">
                            <img src="../../assets/images/top2.png" alt="top2" class="img-fluid">
                        </div>
                        <div class="awesome">
                            <img src="../../assets/images/top3.png" alt="top3" class="img-fluid">
                        </div>
                        <div class="profile-1">
                            <img src="../../assets/images/top4.png" alt="top4" class="img-fluid">
                        </div>
                        <div class="emoji">
                            <img src="../../assets/images/top5.png" alt="top5" class="img-fluid">
                        </div>
                        <div class="profile-2">
                            <img src="../../assets/images/top1.png" alt="top1" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  
</template>
<script>
export default {
  name: 'Slider'
}
</script>
